import React from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import useCountdown from "@hooks/useCountdown";
import { isDark } from "@common/utils/colors";

const PREFIX = "ProductReleaseCountdown";

const classes = {
  row: `${PREFIX}-row`,
  text: `${PREFIX}-text`,
};

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  // marginTop: theme.spacing(1.5),

  [`& .${classes.text}`]: {
    fontWeight: 500,
    color: isDark(theme.palette.primary.main)
      ? theme.palette.primary.contrastText
      : theme.palette.secondary.main,
  },
}));

const ProductReleaseCountdown = ({ product }) => {
  const currentTime = new Date();
  const startTime = new Date(product.available_start_time);
  const endTime = new Date(product.available_end_time);
  const futureDate = startTime > currentTime ? startTime : endTime;

  const { days, hours, minutes, seconds } = useCountdown(futureDate);

  const padNum = (num) => String(num).padStart(2, "0");

  const renderCountdown = () => {
    if (days > 0) {
      if (days == 1) {
        return days + " day";
      }
      return days + " days";
    }

    if (hours > 0) {
      return padNum(hours) + "h : " + padNum(minutes) + "m : " + padNum(seconds) + "s";
    }

    return padNum(minutes) + "m : " + padNum(seconds) + "s";
  };

  return (
    <Root>
      <Typography variant="body1" className={classes.text}>
        {startTime > currentTime ? "Starting in " : "Ending in "} {renderCountdown()}
      </Typography>
    </Root>
  );
};

export default ProductReleaseCountdown;
